/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/

export const GLOBAL_PUBLIC_PERSPECTIVE_ID = '00000000-0000-0000-0000-000000000000'
